import copy from 'assets/icons/copy-alt.svg';
import styled, { from } from 'theme';

export const IntegrationDataWrapper = styled.div`
  .secret-field {
    margin: -0.5rem 0;

    .secret-field__text {
      width: 6rem;

      ${from('md')} {
        width: 5rem;
      }

      ${from('lg')} {
        width: 11.375rem;
      }
    }

    .secret-field__toggle,
    .secret-field__copy {
      color: ${props => props.theme.variables.customColors.lightNavy};
      min-width: 0;
      margin-left: 0.9375rem;
      font-weight: ${props => props.theme.variables.fonts.weight.regular};
      background-color: transparent;

      &:hover {
        color: ${props => props.theme.variables.customColors.leadingColor.base};
        background-color: transparent;
      }
    }

    .secret-field__copy {
      &::before {
        background-image: url(${copy});
        background-size: 0.75rem 0.75rem;
        display: inline-block;
        width: 0.75rem;
        height: 0.75rem;
        content: '';
        vertical-align: middle;
        margin-right: 0.375rem;
      }
    }
  }
`;

export const IntegrationDataCertificatesInfo = styled.div`
  margin-top: 4rem;
  color: ${props => props.theme.variables.customColors.lightGreyText};
  font-size: ${p => p.theme.variables.fonts.size.smaller1};
  display: flex;
  align-items: center;
  img {
    width: 1.3rem;
    height: 1.3rem;
    vertical-align: middle;
    margin-right: 0.375rem;
  }
`;
